import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconPerplexity: FC<IconProps> = ({ size = 40, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2689_6782)">
      <path
        d="M31.3531 2.5V13.105H35.3125V28.1958H31.0323V37.5L20.77 28.4671V37.4285H19.179V28.4569L8.905 37.5V28.0719H4.6875V12.9825H8.89333V2.5L19.179 11.9704V2.77708H20.7685V12.2417L31.3531 2.5ZM20.77 15.6892V26.3627L29.4413 33.9956V23.5583L20.77 15.6892ZM19.1673 15.5725L10.496 23.4446V33.9956L19.1673 26.3627V15.574V15.5725ZM31.0323 26.6267H33.7215V14.6756H22.1292L31.0323 22.7548V26.6267ZM17.9335 14.5517H6.27708V26.5027H8.90208V22.746L17.9321 14.5502L17.9335 14.5517ZM10.4844 6.11083V12.9796H17.9438L10.4844 6.11083ZM29.7621 6.11083L22.3027 12.9796H29.7621V6.11083Z"
        fill="#22B8CD"
      />
    </g>
    <defs>
      <clipPath id="clip0_2689_6782">
        <rect width="35" height="35" fill="white" transform="translate(2.5 2.5)" />
      </clipPath>
    </defs>
  </svg>
);

IconPerplexity.defaultProps = defaultIconProps;
